import config from '../../config'
import { useCallback, useMemo } from 'react'
import axios from 'axios'
import { useMutation } from '@tanstack/react-query'

import { IUseDeleteMutation, IDeleteFn, ITrainingPersonRequirement, IGetDeleteRequest } from '../../interfaces'

const getDeleteTrainingPersonRequirementMutationRequest: IGetDeleteRequest = params => {
  return {
    method: 'delete',
    url: `${config.baseUrl}/PersonTrainingRequirements/`,
  }
}

const useDeleteTrainingPersonRequirementMutation: IUseDeleteMutation<ITrainingPersonRequirement, number> = (params, options = {}) => {
  const request = useMemo(() => getDeleteTrainingPersonRequirementMutationRequest(params), [params])

  const deleteTraining: IDeleteFn<ITrainingPersonRequirement> = useCallback(
    async id => {
      return axios({ ...request, url: request.url + id }).then(res => res.data)
    },
    [request],
  )

  const response = useMutation<ITrainingPersonRequirement, Error, any>({ mutationFn: deleteTraining, ...options })

  return response
}

export default useDeleteTrainingPersonRequirementMutation
